import React, { createContext, useContext, useState } from 'react';

const AuthModalContext = createContext();

export function AuthModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [mode,   setMode]   = useState('signin'); // 'signin' | 'signup' | 'forgot'

  const openAuthModal = (initialMode = 'signin') => {
    setMode(initialMode);
    setIsOpen(true);
  };
  const closeAuthModal = () => setIsOpen(false);

  return (
    <AuthModalContext.Provider value={{ isOpen, mode, setMode, openAuthModal, closeAuthModal }}>
      {children}
    </AuthModalContext.Provider>
  );
}

export function useAuthModal() {
  return useContext(AuthModalContext);
}